export default "__VITE_ASSET__lgWTn070__"